import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useState, useEffect } from 'preact/hooks'

export default function NoResults() {
    const {
        response: { query }
    } = useAppState()

    const [queryNoResult, setQueryNoResult] = useState('');


    const handleInputChange = (event) => {
        setQueryNoResult(event.target.value);
    };
  
    const handleFormSubmit = (event) => {
      event.preventDefault();
      const encodedQuery = encodeURIComponent(queryNoResult);
      const redirectURL = `/search?q=${encodedQuery}`;
       window.location.href = redirectURL;
    };

    return (
        <div class="ns-EmptyState">
            <div class="nosto-rec-container">
                <div class="nosto_element" id="noresults-nosto-1"></div>
            </div>
            <div class="ns-Container">
                <h1 class="EmptyState__Title Heading u-h5">Search</h1>
                <p>{`No results could be found for ${query}`}</p>
                <div class="ns-EmptyState__Action">
                    <form method="GET" action="/search" class="Form" onSubmit={handleFormSubmit}>
                        <input id="ns-search" class="Form__Input"                         
                         onChange={handleInputChange}
                            value={query}
                            type="text" name="q" autocomplete="off" autocorrect="off" aria-label="Search..." placeholder="Search..."/>
                    </form>
                </div>
            </div>
        </div>

       
    )
}
